// KL 23.10.2026: wyszukiwarka A (kanwa 5p1rfCFH9ebDeYkZuJsEbC) + okragle "+" do koszyka z wersji C.
// Lupa w naglowku (motyw: on:click="#search-modal/showDialog") otwiera <dialog id="kl-sz"> zamiast okna motywu.
// Przechwycenie na window w fazie capture (motyw lapie zdarzenia na document - patrz pulapka quick-add).
// Wyniki: /search/suggest?section_id=kl-szukaj, licznik: /search?section_id=kl-szukaj-licznik (ten sam adres co strona wynikow).
// "+": produkt z jednym wariantem i dostepny -> /cart/add.js z sekcjami koszyka + zdarzenie cart:update (jak kl-zs.js).
(() => {
  if (window.__klSz) return;
  window.__klSz = true;

  const MIN_DESKTOP = 750;
  let dlg, inp, wyniki, start, stopka, wszystkie, licznikEl, status, wyczysc;
  let ostatniTrigger = null;
  let timer = 0;
  let kontroler = null;
  let ostatnieQ = null;
  const cache = new Map();
  const licznikCache = new Map();

  const szukajUrl = (q) => {
    const u = new URL(dlg.dataset.szukajUrl || '/search', location.origin);
    u.searchParams.set('q', q);
    u.searchParams.set('options[prefix]', 'last');
    return u;
  };

  function init() {
    dlg = document.getElementById('kl-sz');
    if (!dlg) return false;
    inp = dlg.querySelector('[data-kl-sz-q]');
    wyniki = dlg.querySelector('[data-kl-sz-wyniki]');
    start = dlg.querySelector('[data-kl-sz-start]');
    stopka = dlg.querySelector('[data-kl-sz-stopka]');
    wszystkie = dlg.querySelector('[data-kl-sz-wszystkie]');
    licznikEl = dlg.querySelector('[data-kl-sz-n]');
    status = dlg.querySelector('[data-kl-sz-status]');
    wyczysc = dlg.querySelector('[data-kl-sz-wyczysc]');

    inp.addEventListener('input', () => {
      wyczysc.hidden = !inp.value;
      clearTimeout(timer);
      timer = setTimeout(() => szukaj(inp.value), 180);
    });
    wyczysc.addEventListener('click', () => {
      inp.value = '';
      wyczysc.hidden = true;
      szukaj('');
      inp.focus();
    });
    dlg.querySelectorAll('[data-kl-sz-zamknij]').forEach((b) => b.addEventListener('click', zamknij));
    // klikniecie w tlo (poza panelem) zamyka
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) zamknij();
    });
    dlg.addEventListener('close', poZamknieciu);
    dlg.addEventListener('keydown', pulapkaFokusu);
    dlg.querySelector('[data-kl-sz-form]').addEventListener('submit', (e) => {
      if (!inp.value.trim()) e.preventDefault();
    });
    dlg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-kl-sz-dodaj]');
      if (b) {
        e.preventDefault();
        dodaj(b);
      }
    });
    return true;
  }

  function ustawGore() {
    let top = 0;
    if (window.innerWidth >= MIN_DESKTOP) {
      const h = document.querySelector('#header-component, header-component, .header');
      if (h) top = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
      if (top > window.innerHeight * 0.5) top = 0;
    }
    dlg.style.setProperty('--kl-sz-top', top + 'px');
  }

  function otworz(trigger) {
    if (!dlg && !init()) return false;
    ostatniTrigger = trigger || document.activeElement;
    ustawGore();
    if (!dlg.open) dlg.showModal();
    document.documentElement.classList.add('kl-sz-otwarte');
    inp.focus();
    if (inp.value) inp.select();
    else szukaj('');
    return true;
  }

  function zamknij() {
    if (dlg && dlg.open) dlg.close();
  }

  function poZamknieciu() {
    document.documentElement.classList.remove('kl-sz-otwarte');
    if (ostatniTrigger && document.contains(ostatniTrigger) && typeof ostatniTrigger.focus === 'function') {
      try { ostatniTrigger.focus({ preventScroll: true }); } catch (_) {}
    }
  }

  const fokusowalne = () =>
    Array.from(dlg.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')).filter(
      (el) => el.offsetParent !== null || el === document.activeElement
    );

  function pulapkaFokusu(e) {
    if (e.key !== 'Tab') return;
    const f = fokusowalne();
    if (!f.length) return;
    const pierwszy = f[0];
    const ostatni = f[f.length - 1];
    if (e.shiftKey && document.activeElement === pierwszy) {
      e.preventDefault();
      ostatni.focus();
    } else if (!e.shiftKey && document.activeElement === ostatni) {
      e.preventDefault();
      pierwszy.focus();
    }
  }

  function pokazStart() {
    start.hidden = false;
    wyniki.hidden = true;
    wyniki.innerHTML = '';
    stopka.hidden = true;
    status.textContent = '';
  }

  async function szukaj(surowe) {
    const q = surowe.trim();
    if (q === ostatnieQ && !wyniki.hidden) return;
    ostatnieQ = q;
    if (kontroler) kontroler.abort();
    if (!q) {
      pokazStart();
      return;
    }
    kontroler = new AbortController();
    const sygnal = kontroler.signal;
    wyniki.setAttribute('aria-busy', 'true');
    ustawStopke(q, licznikCache.get(q));
    try {
      let html = cache.get(q);
      if (!html) {
        const u = new URL(dlg.dataset.suggestUrl || '/search/suggest', location.origin);
        u.searchParams.set('q', q);
        u.searchParams.set('resources[type]', 'product,collection,query');
        u.searchParams.set('resources[limit]', '8');
        u.searchParams.set('resources[limit_scope]', 'each');
        u.searchParams.set('section_id', 'kl-szukaj');
        const r = await fetch(u, { signal: sygnal });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        const tekst = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = tekst;
        const w = tmp.querySelector('[data-kl-sz-wyn]');
        html = w ? w.outerHTML : '';
        cache.set(q, html);
      }
      if (sygnal.aborted) return;
      wyniki.innerHTML = html;
      wyniki.hidden = false;
      start.hidden = true;
      wyniki.setAttribute('aria-busy', 'false');
      const body = dlg.querySelector('[data-kl-sz-body]');
      if (body) body.scrollTop = 0;
      const w = wyniki.querySelector('[data-kl-sz-wyn]');
      const ileProd = w ? parseInt(w.dataset.produkty, 10) || 0 : 0;
      stopka.hidden = false;
      status.textContent = ileProd ? `Podpowiedzi dla „${q}”: ${ileProd} produktów na liście.` : `Brak produktów w podpowiedziach dla „${q}”.`;
      pobierzLicznik(q, sygnal);
    } catch (e) {
      if (sygnal.aborted) return;
      wyniki.setAttribute('aria-busy', 'false');
      wyniki.hidden = false;
      start.hidden = true;
      wyniki.innerHTML = '<div class="kl-sz-brak"><p class="kl-sz-brak__tyt">Nie udało się pobrać podpowiedzi.</p><p>Wciśnij Enter, aby zobaczyć wyniki wyszukiwania.</p></div>';
      stopka.hidden = false;
    }
  }

  function ustawStopke(q, n) {
    wszystkie.href = szukajUrl(q).pathname + szukajUrl(q).search;
    if (n == null || n === '' || isNaN(n)) {
      licznikEl.textContent = '';
    } else {
      const liczba = Number(n);
      licznikEl.textContent = liczba >= 1000 ? ' (1000+)' : ` (${liczba})`;
    }
  }

  async function pobierzLicznik(q, sygnal) {
    if (licznikCache.has(q)) {
      ustawStopke(q, licznikCache.get(q));
      return;
    }
    try {
      const u = szukajUrl(q);
      u.searchParams.set('section_id', 'kl-szukaj-licznik');
      const r = await fetch(u, { signal: sygnal });
      if (!r.ok) return;
      const t = await r.text();
      const m = t.match(/data-kl-sz-licznik="(\d+)"/);
      if (!m) return;
      licznikCache.set(q, m[1]);
      if (!sygnal.aborted && ostatnieQ === q) ustawStopke(q, m[1]);
    } catch (_) {}
  }

  // --- "+" do koszyka ---
  const sekcjeKoszyka = () =>
    Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((e) => e.dataset.sectionId)));

  function pokazBlad(btn, txt) {
    const kafel = btn.closest('.kl-sz-kafel');
    if (!kafel) return;
    let p = kafel.querySelector('.kl-sz-blad');
    if (!p) {
      p = document.createElement('p');
      p.className = 'kl-sz-blad';
      p.setAttribute('role', 'alert');
      kafel.appendChild(p);
    }
    p.textContent = txt;
  }

  async function dodaj(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    const id = Number(btn.dataset.klSzDodaj);
    if (!id) return;
    const nazwa = btn.dataset.nazwa || '';
    btn.setAttribute('aria-busy', 'true');
    const stary = btn.closest('.kl-sz-kafel') && btn.closest('.kl-sz-kafel').querySelector('.kl-sz-blad');
    if (stary) stary.remove();
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }],
          sections: sekcjeKoszyka().join(','),
          sections_url: window.location.pathname,
        }),
      });
      const dane = await r.json();
      if (!r.ok || dane.status) throw new Error(dane.description || dane.message || 'Nie udało się dodać do koszyka.');
      const koszyk = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json());
      if (document.querySelector('.cart-page')) window.__paLastCartMutation = 0;
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: koszyk,
        sourceId: 'kl-szukaj',
        data: { source: 'kl-szukaj', itemCount: koszyk.item_count, variantId: String(id), sections: dane.sections || {} },
      };
      document.dispatchEvent(ev);
      btn.removeAttribute('aria-busy');
      btn.classList.add('is-ok');
      btn.setAttribute('aria-label', 'Dodano do koszyka: ' + nazwa);
      status.textContent = 'Dodano do koszyka: ' + nazwa + '. W koszyku: ' + koszyk.item_count + ' szt.';
      setTimeout(() => {
        btn.classList.remove('is-ok');
        btn.setAttribute('aria-label', 'Dodaj do koszyka: ' + nazwa);
      }, 2500);
    } catch (e) {
      btn.removeAttribute('aria-busy');
      const txt = (e && e.message) || 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
      pokazBlad(btn, txt);
      status.textContent = txt;
    }
  }

  // --- przechwycenie lupy motywu ---
  const SEL = '[on\\:click="#search-modal/showDialog"], .search-modal__button';
  window.addEventListener(
    'click',
    (e) => {
      const t = e.target && e.target.closest && e.target.closest(SEL);
      if (!t) return;
      if (t.closest('#kl-sz')) return;
      if (!document.getElementById('kl-sz')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      otworz(t);
    },
    true
  );

  window.klSzukaj = { otworz, zamknij };
})();
